export default __webpack_public_path__ + "static/media/madlibs.7895d239.png";